<section class="px-4 bg-ayr-white dark:bg-ayr-black text-ayr-black dark:text-ayr-white py-11">
    <div class="grid grid-cols-12 max-w-960 m-auto grid-rows-2 gap-4 gap-y-9 relative">
        <div class="col-span-12 sm:col-span-5 text-15 lg:text-18">
            <h2 class="text-27 lg:text-47 font-bold">
                <span class="ayr-underline dark:text-shadow  ">{{'citizens.sustainable-choices.header.sustainable' | translate}}</span>
                <br />
                <span class="ayr-underline dark:text-shadow  ">{{'citizens.sustainable-choices.header.choices' | translate}}</span>
            </h2>
            <p class="max-w-[200px] mt-4 sm:max-w-none">
                {{'citizens.sustainable-choices.content.first' | translate}}
            </p>

            <p class="max-w-[200px] mt-4 sm:max-w-none">
                {{'citizens.sustainable-choices.content.second' | translate}}
                {{'citizens.sustainable-choices.content.third' | translate}}
            </p>

            <p class="max-w-[200px] mt-4 sm:max-w-none font-bold ">
                {{'citizens.sustainable-choices.content.fourth' | translate}}
                {{'citizens.sustainable-choices.content.fifth' | translate}}
                {{'citizens.sustainable-choices.content.sixth' | translate}}
            </p>
        </div>

        <picture class="hidden md:inline-block col-start-6 col-end-9 self-end">
            <source
                src="https://storage.googleapis.com/weayr-assets-non-prod/images/citizens/pedro-menezes-OSCabJzBru0-unsplash-3@2x.avif"
                type="image/avif">
            <img
                src="https://storage.googleapis.com/weayr-assets-non-prod/images/citizens/pedro-menezes-OSCabJzBru0-unsplash-3@2x.webp"
                alt="ayr_citizens" loading="lazy">
        </picture>
        <picture class="hidden sm:inline-block sm:col-start-8 md:col-start-9 col-end-13 self-end mb-16">
            <source
                src="https://storage.googleapis.com/weayr-assets-non-prod/images/citizens/pedro-menezes-OSCabJzBru0-unsplash-3@2x (1).avif"
                type="image/avif">
            <img
                src="https://storage.googleapis.com/weayr-assets-non-prod/images/citizens/pedro-menezes-OSCabJzBru0-unsplash-3@2x (1).webp"
                alt="ayr_citizens" loading="lazy">
        </picture>

        <div class="absolute hidden sm:block col-span-6 col-end-7 row-start-2 md:mt-24">
            <picture>
                <source
                    src="https://storage.googleapis.com/weayr-assets-non-prod/images/citizens/pedro-menezes-OSCabJzBru0-unsplash-6@2x.avif"
                    type="image/avif">
                <img
                    src="https://storage.googleapis.com/weayr-assets-non-prod/images/citizens/pedro-menezes-OSCabJzBru0-unsplash-6@2x.webp"
                    alt="ayr_citizens" loading="lazy">
            </picture>
        </div>

        <div class="absolute hidden md:block sm:col-start-1 md:col-start-6 col-end-8 row-start-2 ">
            <picture>
                <source
                    src="https://storage.googleapis.com/weayr-assets-non-prod/images/citizens/pedro-menezes-OSCabJzBru0-unsplash-2@2x.avif"
                    type="image/avif">
                <img
                    src="https://storage.googleapis.com/weayr-assets-non-prod/images/citizens/pedro-menezes-OSCabJzBru0-unsplash-2@2x.webp"
                    alt="ayr_citizens" loading="lazy">
            </picture>
        </div>

        <div
            class="max-w-[200px] sm:max-w-none sm:col-start-8 col-span-12 sm:col-span-5 row-start-2 text-right text-15 lg:text-18 justify-self-end">
            <h2 class="text-27 lg:text-47 font-bold">
                <span class="ayr-underline dark:text-shadow  ">{{'citizens.involved-communities.header.involved' | translate}}</span>
                <br />
                <span class="ayr-underline dark:text-shadow  ">{{'citizens.involved-communities.header.communities' | translate}}</span>
            </h2>
            <p class="mt-4">
                {{'citizens.involved-communities.content.first' | translate}}
                {{'citizens.involved-communities.content.second' | translate}}
            </p>

            <p class="mt-4">
                {{'citizens.involved-communities.content.third' | translate}}
                {{'citizens.involved-communities.content.fourth' | translate}}
            </p>

            <p class="mt-4">
                {{'citizens.involved-communities.content.fifth' | translate}}
                {{'citizens.involved-communities.content.sixth' | translate}}
                {{'citizens.involved-communities.content.seventh' | translate}}
            </p>
        </div>
    </div>

</section>